import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { PageTitleService } from '@rd/core/services/page-title/page-title.service';
import { AnzAnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'rd-anz-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnzPageNotFoundComponent implements OnInit {
  @HostBinding('class.rd-anz-page-not-found') componentClass = true;

  constructor(
    private iconRegistryService: IconRegistryService,
    private anzAnalyticsService: AnzAnalyticsService,
    private pageTitleService: PageTitleService,
  ) {}

  ngOnInit(): void {
    this.registerIcons();
    this.pageTitleService.setPageTitle('not-found');
    this.anzAnalyticsService.track({
      routeName: this.anzAnalyticsService.sitemap.notFound,
    });
  }

  registerIcons(): void {
    this.iconRegistryService.registerIcon('not-found');
  }
}
